<template>
  <div class="hello" id="hello-wrapper">
    
  <swiper :options="GlobalswiperOption" ref="GlobalSwiper" id="GlobalSwiper">

    <swiper-slide>
      <div class="hello-card-cont">
        <div class="hello-card">
          <div class="hello-name">Какой вы бульдозер? Или самосвал?</div>
        <div class="hello-text">Мы обновили раздел спецтехники на Авто.ру, но очень вероятно, что вам это неинтересно, поэтому мы сделали про спецтехнику онлайн-тест. Он мало того, что интересный, так ещё и познавательный. Пройдите его, если сможете!</div>
        <div class="start-img-wrapper">
          <img class="start-img" src="content/data/3.png">
        </div>
        <button v-on:click="Start" class="button-one">НАЧАТЬ ТЕСТ</button>
        </div>
      </div>
    </swiper-slide>

    <swiper-slide>
      <swiper :options="swiperOption" ref="mySwiper" id="mySwiper">
        <swiper-slide v-for="slide,index in swiperSlides" :key="index">
          <div class="slide-card">
            <div class="question-name">{{slide.question}}</div>
            <div class="photos-container">
              <div v-if="!slide.winner" class="img-container">
                <div v-for="n in 4" :key="n" v-on:click="Selected(index,n)" class="image-and-text">
                  <img :src="'content/data/'+ (index+1) +'/'+ n +'.png'" class="img-choice">
                  <transition name="fade">
                  <div class="border-wrapper" v-bind:class="ColorBorder(index,n)" :id="uniqueId(index, n)"></div>
                  </transition>
                </div>
              </div>
            </div>
            <transition v-if="answers[index]" name="fade">
              <div>
                <div class="answer-text" v-html="swiperSlides[index].answers[answers[index]-1]"></div>
                <button v-show="index!=7" class="button-next" v-on:click="SlideNext">Следующий вопрос</button>
                 <button v-show="index==7" class="button-next" v-on:click="SlideNext">Узнать результат</button>
              </div>
            </transition>
          </div>
        </swiper-slide>
        <div class="swiper-pagination swiper-pagination-bullets" slot="pagination"></div>
      </swiper>
     </swiper-slide>

    <swiper-slide>
      <div class="goodbye-card">
        <div class="question-name">{{winText.name}}</div>
        <div class="text-block" style="padding-top: 0px;margin-top: -10px;">{{winText.text}}</div>
        <div class="ticket-wrapper"><div class="image-gradient"></div><img class="ticket-image" :src="winImage"></div>
        <div class="guessed-block">Правильных ответов: {{result}} из {{allAnswers}}</div>
        <div class="text-block">Поделитесь результатом с друзьями:</div>
        <div class="social">
          <a class="push facebook" v-on:click="Share_facebook(winURL,TITLE,winIMG,DESC)" data-id="fb"><i class="fa fa-facebook"></i>Facebook</a>
          <a class="push twitter" v-on:click="Share_twitter(winURL,TITLE)" data-id="tw"><i class="fa fa-twitter"></i>Twitter</a>
          <a class="push vkontakte" v-on:click="Share_vkontakte(winURL,TITLE,winIMG,DESC)" data-id="vk"><i class="fa fa-vk"></i>Vkontakte</a>
          <a class="push ok" v-on:click="Share_odnoklassniki(winURL,DESC)" data-id="ok"><i class="fa fa-odnoklassniki"></i>OK</a>
        </div> 
        <div class="text-block">Вся коммерческая техника с удобными фильтрами и быстрым поиском теперь в одном месте — тысячи объявлений о продаже тракторов, бульдозеров, экскаваторов и остальной техники со всей России располагаются в восьми новых категориях.<br>Удобного вам выбора с Авто.ру!</div>
        <a class="button-next button-away" href="https://auto.ru/rossiya/dredge/all/">Посмотреть спецтехнику</a>
        <a class="restart-link" v-on:click="Restart()">Пройти ещё раз</a>
      </div>
    </swiper-slide>

  </swiper>

  <div id="preload">
   <img src="content/data/1/1.png" width="1" height="1" alt="Image 01" />
   <img src="content/data/1/2.png" width="1" height="1" alt="Image 02" />
   <img src="content/data/1/3.png" width="1" height="1" alt="Image 03" />
   <img src="content/data/1/4.png" width="1" height="1" alt="Image 03" />
</div>

  </div>
</template>

<script>

import questions_json from '../../content/data/questions.json'
import results_json from '../../content/data/results.json'

export default {
  name: 'HelloWorld',
  data () {
    return {
      TITLE: 'Пройди тест от Авто.ру',
      DESC: 'Узнай, насколько хорошо ты разбираешься в спецтехнике',
      answers:[],
      result: 0,
      GlobalswiperOption: {
        allowTouchMove: false,
        autoHeight: true,
        spaceBetween: 1,
        slideNext: true,
        spaceBetween: 200
        },
      swiperOption: {
        allowTouchMove: false,
        autoHeight: true,
        spaceBetween: 200,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          bulletActiveClass: 'bullet-active',
          renderBullet(index, className) {
              return `<span class="${className} swiper-pagination-bullet-custom"></span>`
            }
        },
        effect: 'flip'
        },
      swiperSlides: questions_json.questions,
      finalTexts: results_json.results
    }
  },

  computed: {
      globalSwiper() {
        return this.$refs.GlobalSwiper.swiper
      },
      swiper() {
        return this.$refs.mySwiper.swiper
      },
      allAnswers() {
        return this.swiperSlides.length;
      },
      winText(){
        for (var i = this.finalTexts.length - 1; i >= 0; i--) {
          if (this.result >= this.finalTexts[i].border) {
            return this.finalTexts[i]
          }
        }
      },
      winImage(){
        for (var i = this.finalTexts.length - 1; i >= 0; i--) {
          if (this.result >= this.finalTexts[i].border) {
            return this.finalTexts[i].image
          }
        }
      },
      winURL(){
        for (var i = this.finalTexts.length - 1; i >= 0; i--) {
          if (this.result >= this.finalTexts[i].border) {
            var j = i+1;
            return 'https://spec.avto.ru/' + j + '.html';
          }
        }
      },
      winIMG(){
        for (var i = this.finalTexts.length - 1; i >= 0; i--) {
          if (this.result >= this.finalTexts[i].border) {
            var j = i+1;
            return 'https://spec.avto.ru/content/' + j + '.png';
          }
        }
      }
    },

  methods: {
  Share_vkontakte: function(purl, ptitle, pimg, text) {
    var url  = 'http://vkontakte.ru/share.php?';
    url += 'url='          + encodeURIComponent(purl);
    url += '&title='       + encodeURIComponent(ptitle);
    url += '&description=' + encodeURIComponent(text);
    url += '&image='       + encodeURIComponent(pimg);
    url += '&noparse=true';
    this.Share_popup(url);
  },
  Share_odnoklassniki: function(purl, text) {
    var url  = 'http://www.odnoklassniki.ru/dk?st.cmd=addShare&st.s=1';
    url += '&st.comments=' + encodeURIComponent(text);
    url += '&st._surl='    + encodeURIComponent(purl);
    this.Share_popup(url);
  },
  Share_facebook: function(purl, ptitle, pimg, text) {
    var url  = 'http://www.facebook.com/sharer.php?s=100';
    url += '&p[title]='     + encodeURIComponent(ptitle);
    url += '&p[summary]='   + encodeURIComponent(text);
    url += '&p[url]='       + encodeURIComponent(purl);
    url += '&p[images][0]=' + encodeURIComponent(pimg);
    this.Share_popup(url);
  },
  Share_twitter: function(purl, ptitle) {
    var url  = 'http://twitter.com/share?';
    url += 'text='      + encodeURIComponent(ptitle);
    url += '&url='      + encodeURIComponent(purl);
    url += '&counturl=' + encodeURIComponent(purl);
    this.Share_popup(url);
  },

  Share_popup: function(url) {
    window.open(url,'','toolbar=0,status=0,width=626,height=436');
  },

    correctAnswers: function (i) {
        var num = 0;
        for (var i = this.answers.length - 1; i >= 0; i--) {
          if (this.answers[i] === this.swiperSlides[i].correct) {num += 1}
        }
      return num;
    },

    answerText: function (i) {
        if (this.answers[i] == this.swiperSlides[i].correct) {
          return this.swiperSlides[i].wintext
        } else {
          return this.swiperSlides[i].losetext
        }
      },
    uniqueId: function (slide, i) {
      return slide + '-' + i;
    },

    ColorBorder: function (slide, index) {
      return {
          'img-selected': ((this.answers[slide])&&(this.answers[slide] === index)),
          'img-correct': ((this.swiperSlides[slide].correct === index)&&(this.answers[slide]))
        }
    },

    Start: function() {
      this.UpdSwipers();
      window.scrollTo(0,0);
      this.globalSwiper.slideNext(300);
      yaCounter48179585.reachGoal('start');

    },
    Finish: function () {
      this.result = this.correctAnswers();
      this.answers = [];
      this.globalSwiper.slideNext(300);
      this.UpdSwipers();
      yaCounter48179585.reachGoal('finish');
    },
    Restart: function () {
      this.UpdSwipers();
      window.scrollTo(0,0);
      this.swiper.slideTo(0, 0);
      this.globalSwiper.slideTo(1, 200); 
    },
    Selected: function(slide, i) {
      if (this.answers[slide]) return;

      this.$set(this.answers,slide, i); 
      this.result = this.correctAnswers();
    },
    SlideNext: function () {
      if (this.swiper.isEnd) {
        this.Finish();
      }
      this.swiper.slideNext(300);
      this.UpdSwipers();
      window.scrollTo(0,0);
      
    },
    UpdSwipers: function () {
      var self = this;
      setTimeout(function(){
        self.swiper.updateAutoHeight();
        self.globalSwiper.updateAutoHeight();
      }, 280);
    },
    AddFrames: function(slide, i) {
      var selId = slide + '-' + i;
      var winpoint = this.swiperSlides[slide].correct - 1;
      var winId = slide + '-' + winpoint;

      document.getElementById(selId).className += " img-selected";

      document.getElementById(winId).className += " img-correct";
    },
    CountWinner: function () {
      var amount = 0;
      var w = 0;
      for (var i = 0; i < this.answers.length ; i++) {
        if (this.answers[i] > amount) {
          amount = this.answers[i];
          w = i;
        }
      }
      this.winner = w;
    },

  },
  updated() {
  },

  created() {

  },

  mounted() {

    }
}
</script>

<style>

div#preload { display: none; }

h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
    color: #DA392F;
  font-family: 'GerberaBold';
  text-decoration: none;
      -webkit-user-select: none;
  -moz-user-select: none;     
  -ms-user-select: none;     
  user-select: none; 
}
button {
  margin: 30px auto;
  padding: 20px 30px;
  font-size: 20px;
  color: black;
  border:none;
  border-radius: 5px;
  outline: none;
  cursor: pointer;
    -webkit-user-select: none;
  -moz-user-select: none;     
  -ms-user-select: none;     
  user-select: none;           
}

.start-img-wrapper{
margin: 0 auto;
  max-height: 200px;
  height: 30vw;
  min-height: 90px;
  display: block;
}

.start-img{
  height: 100%;
}

.hello{
  width: 80vw;
  min-width: 320px;
  max-width: 800px;
  border-radius: 8px;

}

.swiper-container {
  width: 100%;
      background-color: rgba(0,0,0,0);
      border-radius: 8px;

}
.swiper-slide {
  border-radius: 8px;
  text-align: center;
  font-size: 18px;
  background: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.hello-card-cont{
  display: table;
   border: none;
}
.hello-card{
  display: table-cell;
  vertical-align: middle; 
  background-color: white;
  padding: 20px;
  border-radius: 8px;
}
.goodbye-card{
  display: table-cell;
  vertical-align: middle; 
  background-color: white;
  padding: 20px;
  border-radius: 8px;
}
.hello-name{
  display: block;
  padding: 25px 0 20px;
  font-size: 35px;
  line-height: 30px;
  font-family: 'GerberaBold';
}

.hello-text{
  max-width: 700px;
  padding: 10px;
  margin: 0 auto;
  text-align: center;
}
.slide-card{
  background-color: white;
    padding:  0px 10px;
    border-radius: 8px;
   /* min-height: calc(100vh - 50px);*/
}
.question-name{
  display: block;
  padding:  25px 0 20px;
  font-size: 30px;
  line-height: 30px;
  font-family: 'GerberaBold';
}
.answer-text{
  padding: 10px 10px;
  font-size: 18px;
  margin: -30px auto 0;
  max-width: 80vw;
  min-width: 250px;
  width: 80%;
   text-align: center;
   white-space: pre-wrap;
}
.hyper-link{
  color: #DA392F;
  font-family: 'GerberaBold';
  text-decoration: none;
}

.photos-container{
  margin: 0 auto 20px;
  min-height: 200px;
     border: none;
}
.img-container{
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 20px;
}


.img-correct{
  border: solid 10px #6DC210 !important;
}

.img-selected{
    border: solid 10px #DA392F;
}

.image-and-text { 
  position: relative; 
  display: inline-block;
  width: 30vw;
  height: auto;
  min-width: 130px;
  max-width: 250px;
  margin: 4px 7px;
  box-sizing: border-box;
  cursor: pointer;
}
.img-choice{
  display: block;
  width: calc(100% - 1px);
  height: calc(100% - 1px);
}
.border-wrapper{
  position: absolute;
  top: 0;
  width: calc(100% - 19px);
  height: calc(100% - 19px);
}


.button-start{
  background-color: rgba(253, 217, 83, 1);
}
.button-next{
  margin: 15px auto 50px;
  padding: 15px 50px;
  font-size: 18px;
  background-color: #6DC210;
  border: none;
  border-radius: 5px;
  color: #fff;
  display: inline-block;
}
.button-next:hover{
    background-color: #6DC210;
}
.button-next:active {
    background-color: #6DC210;
}

.text-block{
  padding: 20px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.swiper-pagination-bullets {
    bottom: 15px !important;
}
.swiper-pagination-bullet-custom.bullet-active{
    background: #6DC210;
    opacity: 1;
}

.ticket-wrapper{
  width: 80%;
  height: 80%;
  max-width: 250px;
  margin: 10px auto;
}

.ticket-image{
  width: 100%;
display: inline-block;
}

.guessed-block{
  margin: -15px 0 20px;
}

#share {
  width:100%;
  border:1px solid #eaeaea;
  margin: 0 auto;
  background:#fff;
  text-align:center;
}
.like {
  font-size: 16px;
  font-weight: 700;
  line-height: 50px;
}
.push {
  display: inline-block;
  width: 17%;
  min-width: 100px;
  line-height: 40px;
  margin: 5px 2px 20px 2px;
  font-size: 15px;
  text-align: center;
  color:#fff;
  cursor: pointer;
}
 
.facebook {background-color:#3b5998;}
.facebook:hover {background-color:#2d4373; color:#fff;}
.twitter {background-color:#55acee;}
.twitter:hover {background-color:#2795e9; color:#fff;}
.vkontakte {background-color:#587ea3;}
.vkontakte:hover {background-color:#466482; color:#fff;}
.ok {background-color:#ee8208;}
.ok:hover {background-color:#ee7808; color:#fff;}

.input-email{
  padding: 8px 5px;
  min-width: 150px;
  font-size: 20px;
    outline: none;
      border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border: 2px solid #cccccc;
}
.input-submit{
  background-color: #DA392F;
  font-size: 20px;
  padding: 10px 15px;
  margin-left: -5px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  background-color: rgba(253, 217, 83, 1);
}

.button-one {
  padding: 20px 30px;
  outline: none;
  background-color: #DA392F;
  border: none;
  border-radius: 10px;
  box-shadow: 1px 4px #b63c31;
  margin-bottom: 30px;
  color: #fff;
  font-size: 19px;
}

.button-one:hover{
  background-color: #DA392F;
}

.button-one:active {
  background-color: #DA392F;
  box-shadow: 0 0px #b63c31;
  transform: translateX(1px) translateY(4px);
}

.restart-link{
  text-decoration: underline;
  cursor: pointer;
  color: black;
  display: inline-block;
  width: 100%;
}

@media only screen and (max-width: 500px) {

    html{
        background: #fff;
    }
    #app {
      margin-top: 0;
    }
    .hello{
          width: 100vw;
          min-width: 320px;
    }
    .hello-card{
      padding: 5px;
    }
    .goodbye-card{
      padding: 5px;
    }
    .hello-text{
      font-size: 15px;
    }
    .hello-name{
      font-size: 25px;
      padding: 15px 0 10px;
    }
    .question-name{
     font-size: 22px;
     line-height: 24px;
      padding: 10px 5px;
    }
    .slide-card {
      padding: 0;
    }
    .image-and-text { 
      position: relative; 
      display: inline-block;
      width: 47vw;
      height: auto;
      min-width: 145px;
      margin: 2px 3px;
      box-sizing: border-box;
      cursor: pointer;
    }
    .answer-text{
      font-size: 15px;
      padding: 5px 10px;
      margin-top: -40px;
      max-width: none;
      width: auto;
    }

    .text-block{
      padding: 10px;
    }
    .social{
      width: 250px;
      margin: 0 auto;
    }
    .push{
          margin: 5px 2px;
    }
    .button-away{
      margin: 15px auto 20px;
    padding: 15px 30px;
    font-size: 17px;
    }
}

@media only screen and (min-width: 1500px) {

          #app {
            margin-top: 4vh !important;
          }
    }

    @media only screen and (min-width: 1900px) {

          #app {
            margin-top: 7vh !important;

          }

    }

@media only screen and (min-width: 2100px) {


          #app {
            margin-top: 13vh !important;

          }
          .image-and-text { 
            max-width: 300px;
          }

    }


</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue